import { styled } from '@mui/material';
import { CompGroupsContext } from '../../../../context';

const PREFIX = 'AccordionCompGroup';

export const classes = {
  title: `${PREFIX}-title`,
};

export const StyledCompGroupsContextProvider = styled(CompGroupsContext.Provider)(() => ({
  [`& .${classes.title}`]: {
    fontWeight: 700,
  },
}));

export const StyledTitleSpan = styled('span')(() => ({
  fontWeight: 700,
}));
